export const handleEnterPress = (event, action) => {
    if(event.key === "Enter") {
        action();
    }
}